<template>
    <div class="data_population pos2 mt-20">
        <h4 v-if="selectedSafetyCate === 'all'">{{ topMenuMap['Safety'].listTitle }}</h4>
        <h4 v-else>{{ selectedCateNm }} 발생 목록</h4>
        <span class="txt_r">{{ basdtVal }}</span>
        <div class="tb_st01 mt-10">
            <div class="thead">
                <table>
                    <caption>리스트헤더</caption>
                    <colgroup>
                        <col style="width: 20%;">
                        <col style="width: 30%;">
                        <col style="width: 30%;">
                        <col style="width: 20%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>구분</th>
                            <th>시간</th>
                            <th>위치</th>
                            <th>상황</th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="tbody full scroll">
                <table>
                    <caption>리스트내용</caption>
                    <colgroup>
                        <col style="width: 20%;">
                        <col style="width: 30%;">
                        <col style="width: 30%;">
                        <col style="width: 20%;">
                    </colgroup>
                    <thead style="display: none;">
                        <tr>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-if="dispList.length > 0" >
                            <tr v-for="safety in dispList">
                                <td>{{ safety.safetyCategory }}</td>
                                <td>{{ getDate(safety.registerTime) }}</td>
                                <td>{{ address(safety) }}</td>
                                <td>{{ safety.processState }}</td>
                            </tr>
                        </template>
                        <template v-else>
                            <tr>
                                <td colspan="4">금일 {{ selectedCateNm }} 발생 건이 없습니다.</td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import gripUtil from "@/libs/grip.util";

export default {
    computed: {
        ...mapGetters({
            topMenuList: 'getTopMenuList',
            selectedTopMenu: 'getSelectedTopMenu',
            safetyTodayList: 'getSafetyTodayList',
            selectedSafetyCate: 'getSelectedSafetyCate',
            safetyCodeList: 'getSafetyCodeList',
        }),
        topMenuMap() {
            return gripUtil.toDict(this.topMenuList, 'code');
        },
        basdtVal(){
            if(this.safetyTodayList.length > 0) {
                let basdtVal = this.safetyTodayList[0].registerTime;
                return gripUtil.formatDate(basdtVal, 'yyyy-MM-dd HH:mm') + ' 기준';
            }
            return '';
        },
        selectedCateNm() {
            let title = '';
            if(typeof this.selectedSafetyCate !== 'undefined' && this.selectedSafetyCate !== 'all') {
                if(!!this.safetyCodeList) {
                    this.safetyCodeList.forEach(d => {
                        if(d.commonCode === String(this.selectedSafetyCate)) {
                            title = d.commonCodeNm;
                        }
                    });
                }
            }
            return title;
        },
        dispList() {
            let list = [];
            if(this.safetyTodayList.length > 0) {
                if(this.selectedSafetyCate !== 'all') {
                    let sftCateMap = gripUtil.toMap(this.safetyTodayList, 'safetyCategoryCd');
                    if(typeof sftCateMap[this.selectedSafetyCate] !== 'undefined') {
                        list = sftCateMap[this.selectedSafetyCate];
                    } else {
                        list = [];
                    }
                }else {
                    list = this.safetyTodayList;
                }
            }
            return list;
        },
    },
    methods: {
        address(safety) {
            return safety.newAddress.indexOf('없음') > -1 ? safety.address : safety.newAddress;
        },
        getDate(dateStr) {
            return gripUtil.formatDate(dateStr, 'MM-dd HH:mm')
        },
    },
};
</script>
